import _window from "@/libraries/window";
export default {
    getItem(key) {
        const localStorage = _window.localStorage;
        try {
            return localStorage && localStorage.getItem(key);
        }
        catch (e) {
        }
    },
    setItem(key, value) {
        const localStorage = _window.localStorage;
        try {
            localStorage && localStorage.setItem(key, value);
        }
        catch (e) {
        }
    },
    removeItem(key) {
        const localStorage = _window.localStorage;
        try {
            localStorage && localStorage.removeItem(key);
        }
        catch (e) {
        }
    }
};
